import { useEffect, useState } from "react"

/**
 * Hook personalizado para detectar cuando la pestaña del navegador es visible.
 * @returns {boolean} EsVisible
 */
function usePageVisibility() {
  const [isVisible, setIsVisible] = useState(
    document.visibilityState === "visible"
  )

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === "visible")
    }
    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [])

  return isVisible
}

export default usePageVisibility
